import { AfterViewInit, Component, inject, TemplateRef } from "@angular/core";
import { UnSubscriber } from "../UnSubscriber";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { MobiOfficeUIState } from "../state-management/mobi-office-ui.interface";
import { Observable, map } from "rxjs";
import { select_MOUI_ApplicationDetails, select_MOUI_UserApplications } from "../state-management/mobi-office-ui.selector";
import { GET_MOBIOFFICE_UI_UserApplications } from "../state-management/mobi-office-ui.action";
import { ToastrService } from "ngx-toastr";
import { StorageHandlerService } from "../services";

@Component({
  selector: "mobi-office-lib-application-switch-drawer",
  templateUrl: "./application-switch-drawer.component.html",
  styleUrl: "./application-switch-drawer.component.scss",
  standalone: false,
})
export class ApplicationSwitchDrawerComponent extends UnSubscriber implements AfterViewInit {
  private readonly offcanvasService = inject(NgbOffcanvas);
  private readonly store = inject<Store<MobiOfficeUIState>>(Store);
  private readonly toastr = inject(ToastrService);
  private readonly storageHandlerService = inject(StorageHandlerService);

  constructor() {
    super(); // Call the base class constructor
  }

  ngAfterViewInit(): void {
    this.store.dispatch(GET_MOBIOFFICE_UI_UserApplications());
    this.currentApplication$ = this.store.select(select_MOUI_ApplicationDetails).pipe(map(res => res?.ApplicationDetails));
    this.applicationsList$ = this.store.select(select_MOUI_UserApplications).pipe(map(res => res?.ApplicationsList));
  }

  currentApplication$!: Observable<any>;
  applicationsList$!: Observable<any>;

  onApplicationDrawer(canvas: TemplateRef<any>) {
    this.offcanvasService
      .open(canvas, { ariaLabelledBy: "offcanvas-basic-title", panelClass: "application-switch-drawer", position: "end", backdrop: true })
      .result.then()
      .catch(error => {
        console.log(error);
      });
  }

  onOpenURL(application: Int_Application, applicationElement: HTMLDivElement) {
    if (applicationElement.className.includes("active")) return;
    if (!application.ApplicationUrl) {
      this.toastr.info("Application URL not found", "Info");
      return;
    }
    document.getElementById("application-drawer-close")?.click();

    setTimeout(() => {
      this.storageHandlerService.clearAll();
      window.open(`${application.ApplicationUrl}`, "_blank");
    }, 300);
  }
}

interface Int_Application {
  AID: number;
  CID: number;
  IsActive: boolean;
  ApplicationName: string;
  ApplicationTitle: string;
  ApplicationUrl: any;
  ApplicationLogoName: string;
  ApplicationLogoUrl: string;
  ApplicationLogoType: string;
  ApplicationLogoSize: number;
  ApplicationHeaderLogoName: string;
  ApplicationHeaderLogoUrl: string;
  ApplicationHeaderLogoType: string;
  ApplicationHeaderLogoSize: number;
}
